export default {
    CM: 'Channel Manager',
    PMS: 'Property Management System',
    CRS: 'Central Reservation System',
};
